import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useContext } from 'react';
import { cn } from '@/libs/utils';
import { ArrowDown } from '@/shared/icons/ArrowDown';
import { ArrowUp } from '@/shared/icons/ArrowUp';
import { SortRadioGroupContext } from './SortRadioGroup';
interface SortRadioButtonProps {
  sortBy: string;
  children: ReactNode;
  disabledSortTypeChange?: boolean;
  unselecting?: boolean;
}
export const SortRadioButton = t0 => {
  const $ = _c(20);
  const {
    children,
    sortBy,
    disabledSortTypeChange: t1,
    unselecting: t2
  } = t0;
  const disabledSortTypeChange = t1 === undefined ? false : t1;
  const unselecting = t2 === undefined ? false : t2;
  const {
    sortBy: activeSortBy,
    sortType: activeSortType,
    onSortChange
  } = useContext(SortRadioGroupContext);
  const isActive = activeSortBy === sortBy && (!!activeSortType || !!disabledSortTypeChange) || sortBy === "all" && !activeSortBy;
  let t3;
  if ($[0] !== activeSortBy || $[1] !== activeSortType || $[2] !== disabledSortTypeChange || $[3] !== onSortChange || $[4] !== sortBy || $[5] !== unselecting) {
    t3 = () => {
      const newSortType = disabledSortTypeChange ? undefined : sortBy === activeSortBy && activeSortType === "asc" ? "desc" : unselecting && activeSortType === "desc" ? undefined : "asc";
      onSortChange?.(sortBy === "all" || !newSortType && !disabledSortTypeChange ? {
        sortBy: undefined,
        sortType: undefined
      } : {
        sortBy,
        sortType: newSortType
      });
    };
    $[0] = activeSortBy;
    $[1] = activeSortType;
    $[2] = disabledSortTypeChange;
    $[3] = onSortChange;
    $[4] = sortBy;
    $[5] = unselecting;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = !disabledSortTypeChange || !isActive;
  const t5 = !isActive;
  let t6;
  if ($[7] !== isActive || $[8] !== t4 || $[9] !== t5) {
    t6 = cn("\n        flex items-center gap-1.5 shrink-0\n        h-8 lg:h-10 px-3 lg:px-4\n        rounded-full\n        text-[12px] lg:text-[14px] \n        font-semibold leading-[1.4]\n        transition-all duration-300\n        cursor-default\n      ", {
      "hover:brightness-125 active:brightness-75 cursor-pointer": t4,
      "text-[#EBECFE] bg-[#31324B59]": isActive,
      "text-[#A0A3E2] ring-1 ring-inset ring-[#A0A3E2]": t5
    });
    $[7] = isActive;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== activeSortType || $[12] !== disabledSortTypeChange || $[13] !== isActive) {
    t7 = !disabledSortTypeChange && isActive && <div className="flex size-5 items-center justify-center text-[#A0A3E2]"><ArrowUp className={cn("size-3", {
        "text-[#2A72FD]": isActive && activeSortType === "desc",
        "text-[#A0A3E2]": isActive && activeSortType === "asc"
      })} /><ArrowDown className={cn("size-3", {
        "text-[#2A72FD]": isActive && activeSortType === "asc",
        "text-[#A0A3E2]": isActive && activeSortType === "desc"
      })} /></div>;
    $[11] = activeSortType;
    $[12] = disabledSortTypeChange;
    $[13] = isActive;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== children || $[16] !== t3 || $[17] !== t6 || $[18] !== t7) {
    t8 = <button onClick={t3} type="button" className={t6}>{children}{t7}</button>;
    $[15] = children;
    $[16] = t3;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};